var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIdentityApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 301,
    viewBox: "0 0 428 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_65676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.871 291.048H1.78125",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.888 70.8408C348.435 67.6048 337.317 68.4957 330.185 74.4044C323.842 79.6577 321.762 89.1607 324.764 96.7385C328.351 105.781 338.69 110.706 348.055 109.139C348.681 109.037 347.512 113.379 344.817 115.816C343.762 116.779 342.696 117.68 341.446 118.315C347.205 117.864 352.831 115.427 354.368 109.242C361.233 107.102 371.347 100.804 371.613 91.8027C371.89 82.4635 365.424 74.1074 356.888 70.851V70.8408Z",
    fill: "white",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.865 161.631V174.206",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.865 201.455V214.03",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.643 187.836H362.226",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.504 187.836H402.087",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.328 169.301L366.222 178.2",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.508 197.462L394.402 206.361",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.328 206.361L366.222 197.462",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.508 178.2L394.402 169.301",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.793 195.425L363.404 193.366",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.324 182.296L394.985 179.337",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.728 207.744L381.408 200.278",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.321 175.384L367.719 169.526",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.553 179.981L363.332 182.46",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.396 193.202L395.795 196.377",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.016 206.135L370.495 200.35",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.232 175.312L383.712 169.526",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.932 147.971C367.628 150.572 368.335 153.183 369.032 155.784",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.328 138.304C364.779 139.973 365.23 141.642 365.67 143.311",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.181 148.759C384.484 151.36 383.777 153.971 383.08 156.572",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.774 139.092C387.323 140.761 386.872 142.43 386.432 144.099",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.986 154.299C398.183 156.306 396.389 158.313 394.586 160.32",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.667 146.854C405.509 148.145 404.361 149.425 403.203 150.715",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.659 165.563C407.354 166.956 405.038 168.349 402.732 169.742",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.901 178.927C424.19 179.183 422.479 179.449 420.768 179.705",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.32 195.28C413.645 194.891 410.981 194.502 408.307 194.103",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.218 196.734C424.506 196.478 422.795 196.233 421.084 195.977",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.952 209.207C406.728 207.671 404.515 206.145 402.291 204.609",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.191 214.891C415.767 213.908 414.342 212.924 412.918 211.941",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.982 220.215C397.312 218.095 395.631 215.986 393.961 213.866",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.192 228.06C404.116 226.708 403.051 225.346 401.975 223.994",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.593 227.098C383.214 224.425 382.824 221.763 382.445 219.09",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.017 237.001C384.771 235.29 384.525 233.58 384.279 231.87",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.734 227.282C369.154 224.62 369.564 221.957 369.985 219.295",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.197 237.164C367.464 235.454 367.73 233.744 367.997 232.044",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.43 221.414C354.141 219.325 355.852 217.246 357.563 215.157",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.076 229.156C347.173 227.814 348.269 226.483 349.365 225.142",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.266 210.58C344.51 209.084 346.754 207.589 349.008 206.104",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.924 216.119C335.369 215.167 336.803 214.204 338.248 213.252",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.816 195.69C337.491 195.342 340.165 194.994 342.84 194.646",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.887 196.981C326.598 196.755 328.319 196.53 330.031 196.305",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.826 180.842C337.49 181.292 340.144 181.743 342.809 182.183",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.947 179.173C326.648 179.46 328.359 179.746 330.06 180.033",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.754 164.253C343.967 165.789 346.181 167.335 348.404 168.871",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.535 158.539L337.798 161.499",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.754 153.265C353.424 155.384 355.084 157.504 356.754 159.624",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.564 145.4C346.63 146.762 347.706 148.114 348.772 149.476",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.865 161.631V174.206",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.865 201.455V214.03",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.643 187.836H362.226",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.504 187.836H402.087",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.328 169.301L366.222 178.2",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.508 197.462L394.402 206.361",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.328 206.361L366.222 197.462",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.508 178.2L394.402 169.301",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.793 195.425L363.404 193.366",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.324 182.296L394.985 179.337",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.728 207.744L381.408 200.278",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.321 175.384L367.719 169.526",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.553 179.981L363.332 182.46",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.396 193.202L395.795 196.377",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.016 206.135L370.495 200.35",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.232 175.312L383.712 169.526",
    stroke: "#A8F0E7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 59.6279V85.5769",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 141.796V167.745",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5566 113.687H108.522",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.777 113.687H190.753",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3984 75.459L116.761 93.8096",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.539 133.562L174.902 151.913",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3984 151.913L116.761 133.562",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.539 93.8096L174.902 75.459",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.422 129.344L110.952 125.104",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.361 102.269L176.102 96.1553",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.931 154.771L148.086 139.38",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.225 88.004L119.855 75.9307",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8691 97.4971L110.797 102.607",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.502 124.767L177.77 131.31",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.449 151.453L125.562 139.523",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.736 87.8504L152.86 75.9307",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 1.78027V47.7285",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 179.645V225.593",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 113.687H69.8096",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.451 113.687H248.638",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4727 34.5596C68.0065 45.0866 78.5506 55.6239 89.0844 66.1509",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.029 160.034C193.963 170.961 204.896 181.887 215.83 192.813",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4727 192.813C68.0065 182.286 78.5506 171.749 89.0844 161.222",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.029 67.3388C193.963 56.4124 204.896 45.486 215.83 34.5596",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7227 146.097C67.6882 144.336 71.6538 142.575 75.6091 140.813",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.051 87.2974C203.47 84 210.888 80.7027 218.317 77.4053",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.492 198.732C170.793 190.417 167.094 182.102 163.395 173.787",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.556 52.7876C106.995 47.0326 104.433 41.2775 101.871 35.5225",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4355 80.1699C63.8357 82.4842 69.2358 84.7985 74.6359 87.1128",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.303 139.677C205.459 143.169 213.606 146.661 221.762 150.153",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.111 191.851C105.499 186.29 107.886 180.72 110.274 175.159",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.615 53.1767C165.136 47.2886 167.667 41.4004 170.188 35.5225",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.207 31.4463C119.652 36.8225 121.097 42.1884 122.541 47.5645",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.848 11.5088C113.77 14.9495 114.702 18.4005 115.625 21.8413",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.864 33.0645C154.419 38.4406 152.974 43.8065 151.529 49.1827",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.222 13.1367C160.3 16.5775 159.368 20.0284 158.445 23.4692",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42 44.5029C182.701 48.6503 178.991 52.7873 175.271 56.9347",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.203 29.1318C197.825 31.7841 195.438 34.4466 193.061 37.0988",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.392 67.748C201.627 70.6256 196.862 73.4929 192.098 76.3704",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.069 57.0879C221.015 58.9311 217.962 60.7744 214.908 62.6177",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.477 98.4287C213.974 99.2684 208.471 100.108 202.969 100.948",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.9 95.3154C236.375 95.8582 232.839 96.3907 229.314 96.9334",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.112 129.057C214.609 128.248 209.096 127.439 203.594 126.63",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.545 132.058C237.009 131.535 233.484 131.023 229.949 130.501",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.925 157.781C200.344 154.617 195.764 151.452 191.184 148.288",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.913 169.516C218.983 167.489 216.042 165.461 213.111 163.434",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.36 180.494C180.906 176.131 177.453 171.769 174 167.396",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.167 196.694C194.954 193.898 192.741 191.103 190.527 188.297",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.605 194.708C151.816 189.199 151.027 183.7 150.238 178.19",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.536 215.137C155.034 211.604 154.522 208.082 154.02 204.549",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.945 195.066C122.806 189.567 123.657 184.078 124.517 178.579",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77 215.464C119.323 211.942 119.866 208.419 120.419 204.896",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2949 182.973C91.8199 178.672 95.3551 174.371 98.88 170.07",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1992 198.937C77.4638 196.183 79.7284 193.418 81.9827 190.663",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3203 160.628C71.9519 157.546 76.5938 154.464 81.2254 151.392",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.125 172.056C53.0966 170.08 56.0682 168.103 59.0398 166.127",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9609 129.897C57.484 129.18 62.9969 128.453 68.52 127.736",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4766 132.569C35.0118 132.109 38.5572 131.648 42.0924 131.177",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9707 99.2578L68.4375 102.033",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6094 95.8271C35.1241 96.4211 38.649 97.015 42.1637 97.609",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2852 65.0342C70.8553 68.2087 75.4254 71.3832 79.9956 74.5577",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3262 53.2578C52.2568 55.2956 55.1874 57.3335 58.118 59.361",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9121 42.3721C90.3551 46.7447 93.7878 51.1173 97.2308 55.4899",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1445 26.1416C76.3476 28.9474 78.5507 31.7533 80.7641 34.5489",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 59.6279V85.5769",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65 141.796V167.745",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5566 113.687H108.522",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.777 113.687H190.753",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3984 75.459L116.761 93.8096",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.539 133.562L174.902 151.913",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3984 151.913L116.761 133.562",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.539 93.8096L174.902 75.459",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.422 129.344L110.952 125.104",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.361 102.269L176.102 96.1553",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.931 154.771L148.086 139.38",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.225 88.004L119.855 75.9307",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8691 97.4971L110.797 102.607",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.502 124.767L177.77 131.31",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.449 151.453L125.562 139.523",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.736 87.8504L152.86 75.9307",
    stroke: "#168374",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.061 91.4753L339.518 88.0243L345.574 93.7589L356.446 78.7773L361.406 82.4639L347.163 100.589C346.538 101.378 345.369 101.46 344.642 100.763L335.051 91.4958L335.061 91.4753Z",
    fill: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.036 187.191C154.388 176.674 148.834 162.266 148.68 162.02C143.618 153.92 126.783 142.523 132.337 137.311C136.22 133.675 148.486 143.475 148.486 143.475C148.486 143.475 133.259 125.401 138.71 121.11C143.137 117.629 160.126 134.238 160.126 134.238C160.126 134.238 146.518 116.472 151.324 113.154C157.011 109.232 167.063 122.657 182.68 134.832C184.473 136.225 193.224 153.214 199.228 164.017L158.036 187.191Z",
    fill: "white",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 145.308C188.725 145.308 186.02 134.884 185.497 131.197C185.016 127.777 184.862 122.514 184.647 120.394C184.155 115.458 177.945 114.291 174.697 123.384C173.006 128.115 173.816 128.064 172.053 134.699C172.053 134.699 163.446 139.553 162.646 149.425",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.725 145.308C188.725 145.308 186.02 134.884 185.497 131.197C185.016 127.777 184.862 122.514 184.647 120.394C184.155 115.458 177.945 114.291 174.697 123.384C173.006 128.115 173.816 128.064 172.053 134.699C172.053 134.699 163.446 139.553 162.646 149.425",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.255 129.507C325.213 128.667 331.915 128.605 337.755 136.624C341.834 142.235 340.819 145.481 345.994 146.249C353.7 147.386 361.59 129.681 373.107 136.316C382.647 141.805 381.571 157.657 370.771 168.829C354.939 185.193 337.263 176.335 333.831 165.112C330.582 154.462 332.109 144.539 328.369 139.952C324.639 135.364 317.6 135.64 317.6 135.64L318.255 129.507Z",
    fill: "#041613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.884 130.552C370.936 132.498 364.849 132.057 361.498 133.563C358.148 135.068 357.697 138.365 355.596 138.304C353.495 138.232 353.516 132.313 358.844 128.719C364.173 125.124 370.813 127.818 370.884 130.552Z",
    fill: "#041613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.054 131.135C380.435 130.776 380.989 136.019 377.607 136.378C374.226 136.736 373.672 131.493 377.054 131.135Z",
    fill: "#041613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.273 126.23C317.273 126.23 323.738 128.135 323.052 134.668C322.376 141.212 315.336 142.031 315.336 142.031L317.273 126.22V126.23Z",
    fill: "#A8F0E7",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.514 224.619C255.514 224.619 218.604 252.719 211.657 253.896C207.333 254.623 193.848 257.101 180.394 248.981C167.81 241.393 144.693 178.691 144.693 178.691C144.693 178.691 153.311 185.983 178.908 164.58C190.261 155.088 199.432 150.746 199.432 150.746L214.332 184.313C214.332 184.313 251.384 148.698 270.136 149.844C282.566 150.602 292.126 154.913 292.126 154.913",
    fill: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.733 183.955L218.012 191.072C218.012 191.072 255.977 154.351 274.729 155.487C280.795 155.856 286.164 157.075 290.079 158.221L292.118 154.924C292.118 154.924 282.557 150.623 270.128 149.855C253.825 148.862 220.379 177.709 214.723 183.955H214.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.705 178.712C145.033 179.634 165.66 235.331 178.418 247.425C165.834 229.054 149.593 185.164 149.296 184.345C149.644 184.621 158.436 191.175 183.51 170.223C191.964 163.157 199.629 159.389 202.508 157.423L199.444 150.767C199.444 150.767 190.263 155.108 178.92 164.601C153.845 185.553 145.053 178.999 144.705 178.723V178.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.514 224.619C255.514 224.619 218.604 252.719 211.657 253.896C207.333 254.623 193.848 257.101 180.394 248.981C167.81 241.393 144.693 178.691 144.693 178.691C144.693 178.691 153.311 185.983 178.908 164.58C190.261 155.088 199.432 150.746 199.432 150.746L214.332 184.313C214.332 184.313 251.384 148.698 270.136 149.844C282.566 150.602 292.126 154.913 292.126 154.913",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67 179.357C141.805 176.408 152.287 170.448 152.287 170.448L155.812 179.071C155.812 179.071 145.227 181.805 143.67 179.357Z",
    fill: "#041613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.492 195.137C218.492 195.137 216.525 188.655 212.508 180.34",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.073 290.249H385.62C385.303 288.918 384.842 287.597 384.483 286.256C383.51 282.702 370.086 256.231 369.902 236.396C369.738 216.57 364.409 176.193 348.199 163.014C332.121 149.937 324.713 155.497 310.726 154.954C304.936 154.729 293.224 152.845 286.092 155.927C250.248 171.421 238.208 236.785 235.636 247.076C233.074 257.296 222.582 280.275 223.073 290.26V290.249Z",
    fill: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.621 290.25C384.883 287.188 383.336 283.972 381.819 279.927C372.003 253.937 371.757 245.264 365.496 203.504",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.735 290.25C222.059 280.398 233.043 257.368 235.636 247.066C236.722 242.735 241.835 216.274 246.18 198.363",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.576 258.136C277.576 258.136 284.339 269.584 296.625 276.364",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.496 264.157C270.496 264.157 274.82 271.479 282.669 275.811",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.133 253.282C271.142 255.913 249.757 253.886 247.39 259.846C243.711 269.083 273.007 269.564 273.007 269.564L281.133 253.271V253.282Z",
    fill: "white",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.286 257.204C261.286 257.204 259.964 263.164 249.758 259.744",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.107 248.008C306.125 248.673 293.89 248.755 282.26 252.206C242.809 263.931 242.369 286.9 249.757 284.73C249.757 284.73 247.328 287.464 249.798 291.867C250.351 292.86 254.767 296.66 260.823 289.635C260.823 289.635 256.468 297.202 262.135 298.595C266.603 299.691 270.117 293.557 282.444 290.249C288.172 292.666 299.792 294.089 309.875 292.072C313.595 291.324 322.705 288.559 321.67 288.764C323.647 288.324 323.965 256.169 309.107 248.018V248.008Z",
    fill: "white",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.812 289.635C264.276 285.293 272.504 279.415 272.504 279.415",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.756 284.74C252.84 279.907 263.558 271.407 263.558 271.407",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.021 154.422C355.26 146.854 368.068 166.598 381.246 195.086C394.423 223.575 411.905 259.446 401.842 277.746C400.479 280.224 393.132 292.953 376.358 295.083C353.323 298.022 309.271 299.22 309.271 299.22C309.271 299.22 317.602 294.97 311.679 271.817C305.265 246.718 305.9 242.263 305.9 242.263C305.9 242.263 330.821 236.764 344.798 236.815",
    fill: "#A8F0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.021 154.422C355.26 146.854 368.068 166.598 381.246 195.086C394.423 223.575 411.905 259.446 401.842 277.746C400.479 280.224 393.132 292.953 376.358 295.083C353.323 298.022 309.271 299.22 309.271 299.22C309.271 299.22 317.602 294.97 311.679 271.817C305.265 246.718 305.9 242.263 305.9 242.263C305.9 242.263 330.821 236.764 344.798 236.815",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.275 236.867C342.275 236.867 337.828 222.223 334.416 212.393",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.353 300.346C305.951 301.135 306.555 291.161 306.555 291.161L313.523 290.618C313.523 290.618 312.181 299.681 309.342 300.336L309.353 300.346Z",
    fill: "#041613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.747 221.936L331.363 215.915",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.977 154.176C338.977 154.176 303.328 178.405 287.005 176.224C272.813 174.329 269.4 149.835 269.4 149.835C269.4 149.835 279.053 149.251 292.517 151.811C310.46 155.221 328.197 149.824 338.977 154.176Z",
    fill: "white",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.007 152.548C290.007 152.548 283.244 159.337 287.486 161.16C294.147 164.017 305.9 154.811 305.9 154.811L290.007 152.548Z",
    fill: "#041613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.986 141.734C321.905 130.48 318.267 117.977 308.871 113.819C299.474 109.651 287.865 115.406 282.946 126.66C278.028 137.914 281.665 150.418 291.062 154.575C300.458 158.743 312.068 152.988 316.986 141.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.062 154.576C293.685 155.733 296.493 156.132 299.259 155.825C297.917 155.63 296.605 155.262 295.324 154.699C286.42 150.746 282.967 138.898 287.629 128.227C292.291 117.557 303.296 112.109 312.211 116.052C312.437 116.154 312.662 116.256 312.877 116.369C311.699 115.335 310.357 114.464 308.871 113.809C299.474 109.651 287.865 115.396 282.946 126.65C278.028 137.904 281.665 150.398 291.062 154.565V154.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.986 141.734C321.905 130.48 318.267 117.977 308.871 113.819C299.474 109.651 287.865 115.406 282.946 126.66C278.028 137.914 281.665 150.418 291.062 154.575C300.458 158.743 312.068 152.988 316.986 141.734Z",
    stroke: "#041613",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.126 143.557C316.126 143.557 297.231 135.969 299.208 117.741C299.208 117.741 292.63 123.322 285.252 122.472C285.252 122.472 294.013 107.142 308.871 113.819C327.848 122.349 316.126 143.557 316.126 143.557Z",
    fill: "#041613"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_65676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 427,
    height: 300,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIdentityApproved);
export default __webpack_public_path__ + "static/media/ic-identity-approved.3bc3aaf70ce217e3cd14ce942719ad3a.svg";
export { ForwardRef as ReactComponent };